module.exports = "/assets/0da0e8bb272685a1455114aaf5c7c0cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/SZ.png
// module id = 1839
// module chunks = 0